import React from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { Behavior } from 'apps/aiAutomation/components/Behavior'
import {
  DisableScenarioConfirm,
  useAutomationStatusToggle,
} from 'apps/aiAutomation/components/DisableScenarioConfirm'
import { EmptyKnowledge } from 'apps/aiAutomation/components/InstantAnswers/components/EmptyKnowledge'
import { KnowledgeProcessing } from 'apps/aiAutomation/components/InstantAnswers/components/KnowledgeProcessing'
import { SetupTab } from 'apps/aiAutomation/components/InstantAnswers/components/SetupTab/SetupTab'
import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader'
import { AiAutomationBehaviorSelectors } from 'apps/aiAutomation/store/behavior'
import { AiAlwaysOnAutomationsSelectors } from 'apps/aiAutomation/store/core'
import { LoaderStatus } from 'apps/aiAutomation/store/core/lib/types'
import { AiAutomationKnowledgeSelectors } from 'apps/aiAutomation/store/knowledge'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { AiAutomationScenario } from 'shared/api/requests/aiAutomation/schemas'
import { typedRouting } from 'utils/router'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'
import { useAccountReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'

import { InvalidKnowledge } from './components/InvalidKnowledge'

import cm from './styles.module.css'

export const InstantAnswers = () => {
  const dispatch = useAppDispatch()

  const navigate = typedRouting.useNavigate()

  const isBehaviorPageEnabled = useAccountReleaseToggle(AccountFlag.ENABLE_AI_BEHAVIOR_PAGE)

  const isBehaviorExists = useAppSelector(AiAutomationBehaviorSelectors.getIsBehaviorExists)
  const isFaqScenarioPublished = useAppSelector(AiAlwaysOnAutomationsSelectors.getFaqScenarioStatus)
  const isKnowledgeFilled = Boolean(useAppSelector(AiAutomationKnowledgeSelectors.getList).length)
  const hasProcessedEntries = Boolean(
    useAppSelector(AiAutomationKnowledgeSelectors.getProcessedEntries).length,
  )
  const isAllEntriesInvalid = useAppSelector(AiAutomationKnowledgeSelectors.getIsAllEntriesInvalid)

  const isLoading =
    useAppSelector(AiAlwaysOnAutomationsSelectors.getLoaderStatus) ===
    LoaderStatus.INSTANT_ANSWERS_STATUS_UPDATING

  const { toggleStatus, isConfirmModalOpen, closeConfirmModal } = useAutomationStatusToggle({
    scenario: AiAutomationScenario.INSTANT_ANSWERS,
    source: 'automation_editor',
  })

  const openUniversalPlayground = () => {
    navigate.aiPlayground()
    dispatch(AiAutomationLayoutActions.sidebarClosed())
  }

  if (isBehaviorPageEnabled && !isBehaviorExists) {
    return <Behavior title={l.translate('AI Replies')} />
  }

  if (isAllEntriesInvalid) {
    return <InvalidKnowledge />
  }

  if (!isKnowledgeFilled) {
    return <EmptyKnowledge />
  }

  if (!hasProcessedEntries) {
    return <KnowledgeProcessing />
  }

  return (
    <section className={cm.wrapper}>
      <SidebarHeader
        title={l.translate('AI Replies')}
        button={
          <div className="d-flex gap-sm">
            <BtnV2 leftIcon="Ai" label={l.translate('Test AI')} onClick={openUniversalPlayground} />

            <BtnV2
              label={isFaqScenarioPublished ? l.translate('Stop') : l.translate('Go Live')}
              ariaLabel={isFaqScenarioPublished ? l.translate('Stop') : l.translate('Go Live')}
              variant={isFaqScenarioPublished ? 'danger-light' : 'primary'}
              loading={isLoading}
              onClick={toggleStatus}
              data-test-id="ai-automation/instant-answers-status-change-button"
            />
          </div>
        }
        className={cm.sidebarHeader}
      />

      <div className={cm.content}>
        <SetupTab />
      </div>

      {isConfirmModalOpen && (
        <DisableScenarioConfirm
          onClose={closeConfirmModal}
          scenario={AiAutomationScenario.INSTANT_ANSWERS}
          source="automation_editor"
        />
      )}
    </section>
  )
}
